<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表号')">
              <a-input :placeholder="$t('输入表号进行查询')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表类型')">
              <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请表类型')" dictCode="meter_type" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!--
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
              -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      -->
      <a-button type="primary" icon="download" @click="handleExportXls('meter_maintenance_warn_last_record')">{{ $t('导出') }}</a-button>
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
        <!--
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
    -->
    <a-tabs v-model="activeKey" @change="changeTab">
      <a-tab-pane :key="1" :tab="$t('电池电压告警')">
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterVoltageWarnDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterVoltageWarnDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          </span>
        </a-table>
      </a-tab-pane>
      <a-tab-pane :key="2" :tab="$t('失联告警')">
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterLostWarnDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterLostWarnDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          </span>
        </a-table>
      </a-tab-pane>
      <a-tab-pane :key="3" :tab="$t('复位告警')">
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterResetWarnDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterResetWarnDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    </div>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import batteryVoltageWarnDetailModal from './modules/batteryVoltageWarnDetailModal'
  import batteryVoltageWarnDealModal from './modules/batteryVoltageWarnDealModal'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import { getAction } from '@/api/manage'
  import {isUndefined} from '@/utils/validate'
  import {meterTypeObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'MeterMaintenanceWarnRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      batteryVoltageWarnDetailModal,
      batteryVoltageWarnDealModal
    },
    data () {
      return {
        description: 'meter_maintenance_warn_record管理页面',
        netTypeObj,
                url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnRecord/list",
          delete: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterMaintenanceWarnLastRecord/importExcel",
          
        },
        dictOptions:{},
        activeKey: 1
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'meterType',
            customRender: (t,r,index) => {
              let data = meterTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('告警描述'),
            align:"center",
            dataIndex: 'meterWarnDetail',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            customRender: (t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('部门编号'),
            align:"center",
            dataIndex: 'sysOrgCode',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('部门名称'),
            align:"center",
            dataIndex: 'departName',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('告警时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      initDictConfig(){
      },
      handleDeal(record) {
        this.$refs.dealModalForm.edit(record);
        this.$refs.dealModalForm.title=this.$t("详情");
        this.$refs.dealModalForm.disableSubmit = false;
      },
      loadData(arg) {
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        if(this.activeKey == 1) {
          params.meterWarnType = 1;
        }else if(this.activeKey == 2) {
          params.meterWarnType = 3;
        }else if(this.activeKey == 3) {
          params.meterWarnType = 4;
        }
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      changeTab() {
        this.loadData(1);
      }
    }
  }
</script>
<style scoped>
</style>